class Skill{
    constructor(icon, text){
        this.icon = icon ?? "";
        this.text = text ?? "";
    }
}

export default Skill